import React from "react";
import "./Button.css";

/**
 * Shared Button component.
 *
 * Props:
 *   variant  — "primary" | "secondary" | "ghost" | "danger"  (default: "primary")
 *   size     — "sm" | "md" | "lg"                             (default: "md")
 *   loading  — bool
 *   disabled — bool
 *   fullWidth — bool
 *   icon     — ReactNode rendered before label
 *   type     — button | submit | reset                         (default: "button")
 *   onClick  — function
 *   className — extra classes
 *   children
 */
const Button = React.forwardRef(({
    variant = "primary", 
    size = "md",
    loading = false,
    disabled = false,
    fullWidth = false,
    icon = null,
    type = "button",
    onClick,
    className = "",
    children,
    ...rest
}, ref) => {
    const classes = [
        "ui-btn",
        `ui-btn--${variant}`,
        `ui-btn--${size}`,
        fullWidth ? "ui-btn--full" : "",
        loading ? "ui-btn--loading" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <button
            ref={ref}
            type={type}
            className={classes}
            disabled={disabled || loading}
            onClick={onClick}
            {...rest}
        >
            {loading && <span className="ui-btn__spinner" />}
            {!loading && icon && icon}
            {children}
        </button>
    );
});

export default Button;
